// extracted by mini-css-extract-plugin
export default {"container":"IbaO9c","date":"W071OC","location":"dLlPeY","separator":"yMjzwK","mobile":"YKfsql"};